// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__occNc","dragIcon":"Choice_dragIcon__vKI3K","left":"Choice_left__37vc9","input":"Choice_input__R20rH"};